import type React from 'react';
import type { ReactElement } from 'react';

import type { OfferAndFilters } from '@/interfaces';
import { ImageObject } from './images/ImageObject';

export const ResultItemImages: React.FC<OfferAndFilters> = ({ offer, filters }): ReactElement<OfferAndFilters> => (
    <div className="grid__unit u-r-size2of5 u-m-ph16 u-mv16" key={offer.hotelId}>
        <div className="ads ads--liquid ads--liquid--cols1to1 u-ma0">
            <div className="ads__unit__img ads__img_mobile">
                <div className="img-format img-format--centered img-format--crop-horizontal overlay__item_1">
                    <ImageObject offer={offer} filters={filters} />
                </div>
            </div>
        </div>
    </div>
);
